import { IConfig, ISite } from "./types";

export const site: ISite = import.meta.env.VITE_SITE as ISite;
export const config: IConfig =
  (import.meta.env.VITE_CONFIG as IConfig) ?? "lfmEnterprise";
export const staging: boolean =
  import.meta.env.VITE_IS_STAGING === "false" ? false : true;
export const sanityToken = import.meta.env.VITE_SANITY_TOKEN;
export const defaultQrUrl =
  import.meta.env.VITE_SCANNER_API ?? "https://reg.thon.test-1.carrot.tech/";
